import React from "react";
import PropTypes from "prop-types";
import ti18n from 'i18n!nls/Sequenceri18n';
import TrebbleProgress from "./common/Progress";
import TrebbleSkeleton from "./common/Skeleton";
import SequencerSearchWidget from "../models/audioEditor/SequencerSearchWidget";

const SEARCH_TYPE = SequencerSearchWidget.SEARCH_TYPE;
const MEDIA_ANALYSIS_REASON = SequencerSearchWidget.MEDIA_ANALYSIS_REASON;

const EditorSearchAnalysisState = ({ 
    isMediaAnalyzedForSilences, 
    shouldSafeBeAvailable, 
    mediaAnalysisProgress,
    searchType,
    mediaAnalysisReason 
}) => {
    if (!isMediaAnalyzedForSilences) {
        return null;
    }

    return (
        <>
            <div className="flex flex-col w-full">
                <span 
                    className="text-left opacity-50 mb-2"
                    style={{
                        background: 'linear-gradient(90deg, #999 25%, #666 50%, #999 75%)',
                        backgroundSize: '200% 100%',
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        color: 'transparent',
                        animation: 'shimmer 2s infinite'
                    }}
                >
                    {mediaAnalysisReason === MEDIA_ANALYSIS_REASON.SAFE_CUT 
                        ? window.getI18n(ti18n, "SCANNING_MEDIA_AVOID_ABRUPT")
                        : mediaAnalysisReason === MEDIA_ANALYSIS_REASON.IMPROVE_SAFETY
                        ? window.getI18n(ti18n, "IMPROVING_SEARCH_RESULTS_SAFETY")
                        : window.getI18n(ti18n, "ANALYZING_MEDIA")
                    }
                </span>
                <TrebbleProgress 
                    percent={Math.round(mediaAnalysisProgress || 0)} 
                    size="small"
                    status="active"
                    style={{ width: '100%' }}
                    useEditorTheme={true}
                />
            </div>
            <div className="flex flex-row justify-center items-center">
                <TrebbleSkeleton.Avatar 
                    active 
                    shape="square" 
                    size="small" 
                    className="my-2"
                    style={{ width: '270px', height: '15px' }} 
                    useEditorTheme={true} 
                />
            </div>
        </>
    );
};

EditorSearchAnalysisState.propTypes = {
    isMediaAnalyzedForSilences: PropTypes.bool,
    shouldSafeBeAvailable: PropTypes.bool,
    mediaAnalysisProgress: PropTypes.number,
    searchType: PropTypes.string,
    mediaAnalysisReason: PropTypes.string
};

export default EditorSearchAnalysisState; 